import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from 'reactstrap'
import activities from '../../../api/activities/hooks'
import { MODAL_TYPES } from '../../../common/constants'
import { EntityParams } from '../../AppPermissionsSwitcher/EntityParamsContext'
import { hideModal } from '../../../store/modal'
import FormContent from './components/FormContent'
import InfoContent from './components/InfoContent'
import { ActivityModalData } from './types'

interface ActivityModalProps {
    isOpen: boolean
    activityModal: {
        event: ActivityModalData
        mode: 'create' | 'edit' | 'view'
        parentId?: string
        detailView?: string
        params?: EntityParams
    }
}

const ActivityModal = (props: ActivityModalProps) => {
    const dispatch = useDispatch()

    const { isOpen, activityModal } = props
    const { event, mode, parentId, detailView, params } = activityModal

    const { data: activity } = activities.GetActivity.useQuery(Number(event?.id), { enabled: !!event?.id })

    // Event props override activity (needed for activity type switching in edit mode)
    const mergedEvent = activity ? { ...activity, ...event } : event

    const [isFormMode, setIsFormMode] = useState(mode === 'create' || mode === 'edit')

    const handleClose = () => {
        dispatch(hideModal({ modalType: MODAL_TYPES.ACTIVITY_MODAL }))
    }

    const handleEdit = () => setIsFormMode(true)

    return (
        <Modal isOpen={isOpen} centered id="event-modal" data-testid="activity-modal">
            {isFormMode ? (
                <FormContent
                    event={mergedEvent}
                    isEdit={!!mergedEvent?.id}
                    parentId={parentId}
                    detailView={detailView}
                    params={params}
                    onClose={handleClose}
                />
            ) : (
                <InfoContent event={mergedEvent} onEdit={handleEdit} onClose={handleClose} />
            )}
        </Modal>
    )
}

export default ActivityModal
